/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconShip2 = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <g
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M5.33 17.848a9.546 9.546 0 0 1 11.136-15.36M1.982 17.78c-1.213 2.125-1.619 3.774-.934 4.46 1.04 1.039 4.294-.43 8.062-3.418M13.423 18.067l-3.58-3.58L17.8 6.53a5.045 5.045 0 0 1 2.353-1.33l2.047-.514a.844.844 0 0 1 1.023 1.023l-.512 2.048a5.059 5.059 0 0 1-1.332 2.352l-7.956 7.958z" />
        <path d="M9.843 14.487l-2.932-.977a.422.422 0 0 1-.165-.7l1.022-1.022a3.383 3.383 0 0 1 3.462-.817l1.6.532-2.987 2.984zM13.423 18.067L14.4 21a.422.422 0 0 0 .7.165l1.022-1.022a3.383 3.383 0 0 0 .817-3.462l-.532-1.6-2.984 2.986z" />
      </g>
    </svg>
  ),
);
